<template>
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <h5 class="mt-3" style="display:block;">
                Taxas Cartão
                <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-primary"
                    @click="showPaymentMethodModal()"
                >
                    <i class="fa fa-plus"></i>
                </a>
            </h5>
            <hr class="mb-3" />
            <div class="row justify-content-start">
                <div class="col-sm-2">
                    <div class="form-group">
                        <label>Imposto %</label>
                        <vue-numeric
                            :separator="vueNumericDefaults.separator"
                            :precision="vueNumericDefaults.decimals"
                            :output-type="vueNumericDefaults.outputType"
                            :disabled="isPartnerTaxDisabled"
                            v-model="selectedCardFees.partnerTax"
                            class="form-control"
                        />
                    </div>
                </div>         
                <div class="col-sm-2">
                    <div class="form-group">
                    <label>Plataforma %</label>
                    <vue-numeric
                        :separator="vueNumericDefaults.separator"
                        :precision="vueNumericDefaults.decimals"
                        :output-type="vueNumericDefaults.outputType"
                        disabled
                        v-model="selectedCardFees.platformFee"
                        v-validate="modelValidations.platformFee"
                        data-vv-name="platformFee"
                        data-vv-as="comissão plataforma"
                        :class="{'form-control': true, 'is-invalid': errors.has('platformFee') ? true : false}"
                    />
                    <div
                        v-show="errors.has('platformFee')"
                        class="invalid-feedback"
                    >{{ errors.first('platformFee') }}</div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label>Dias disponível</label>
                        <select
                            :class="{'form-control': true}"
                            v-model="selectedCardFees.paymentPeriod"
                        >
                            <option
                            v-for="(p, index) in paymentPeriods"
                            :key="index"
                            :value="p.days"                        
                            >{{p.name}}</option>
                        </select>
                        <div
                            v-show="errors.has('paymentPeriod')"
                            class="invalid-feedback"
                        >{{ errors.first('paymentPeriod') }}</div>
                    </div>
                </div>                               
            </div>
            <div class="ctn">
                <div class="payment-methods-container">
                    <div v-for="(p, paymentMethodIdx) in selectedCardFees.fees" :key="paymentMethodIdx" class="payment-method">
                        <div class="form-row">
                            <div class="col-sm-6">
                                <h6 class="mt-2"><strong>{{p.paymentMethod.name}}</strong></h6>
                            </div>
                            <div class="col-sm-6">
                                <div class="d-flex justify-content-center align-items-center" style="height:100%;" v-if="p.paymentMethod.id > 0">
                                    <a href="javascript:void(0);" @click="removePaymentMethod(paymentMethodIdx)">[remover]</a>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <hr />
                            </div>
                        </div>
                        <div class="payment-method-parcels">
                            <div class="payment-method-parcel" v-if="value.source == 'DEVICE'">                                
                                <div class="form-row">
                                    <div class="col-sm-12">
                                        <h6><strong>{{p.debit.name}}</strong></h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Taxa %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="p.debit.fee.partnerFee"
                                                :class="{'form-control': true}"
                                                :key="paymentMethodIdx"
                                            />                            
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Comissão %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="p.debit.fee.salesPersonFee"
                                                :class="{'form-control': true}"
                                                :key="paymentMethodIdx"
                                            />                            
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div class="payment-method-parcel">
                                <div class="form-row">                                
                                    <div class="col-sm-12">
                                        <h6><strong>{{p.creditOnCash.name}}</strong></h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Taxa %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="p.creditOnCash.fee.partnerFee"
                                                :class="{'form-control': true}"
                                                :key="paymentMethodIdx"
                                            />                            
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Comissão %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="p.creditOnCash.fee.salesPersonFee"
                                                :class="{'form-control': true}"
                                                :key="paymentMethodIdx"
                                            />                            
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div v-for="(parcel, parcelIdx) in p.creditParcels" :key="parcelIdx" class="payment-method-parcel">
                                <div class="form-row">                                
                                    <div class="col-sm-12">
                                        <h6><strong>{{parcel.name}}</strong></h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Taxa %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="parcel.fee.partnerFee"
                                                :class="{'form-control': true}"
                                                :key="parcelIdx"
                                            />                            
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Comissão %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="parcel.fee.salesPersonFee"
                                                :class="{'form-control': true}"
                                                :key="parcelIdx"
                                            />                            
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>                                    
                        </div>
                    </div>
                </div>            
            </div>
        </div>
        <b-modal
            id="modal-paymentMethod"
            ref="modal"
            title="Adicionar bandeira:"
            @hidden="resetModal"
            @ok="handleOk"
            ok-title="Salvar"
            cancel-title="Cancelar"
            v-model="paymentMethodModalVisible">
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <div class="form-row">                    
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="paymentMethodLabel">Bandeira</label>
                            <select :class="{'custom-select': true}" v-model="paymentMethodModal.id">
                                <option v-for="(s, index) in paymentMethods" :key="index" :value="s.id" :disabled="s.disabled">
                                    {{s.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>
<script>
import _ from "lodash";
import eventbus from '../../../eventBus';
import paymentMethodService from '../../../services/PaymentMethods/paymentMethodService';
import config from '../../../config'
export default {
    name: 'card-fee',
    inject: ['$validator'],
    props: {
        value: {
            type: Object,
            default: {
                source: '',
                fees: [],
                usePaymentPeriodInstallment: false,
                partnerSettings: {
                    platformFee: 0,
                    patnerTax: 0
                }
            }
        }
    },
    data(){
        return {
            paymentMethodModalVisible: false,
            paymentMethodModal: {
                id: null
            },
            vueNumericDefaults: {
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },
            modelValidations: {
                platformFee: { required: true },
                partnerTax: { required: true }
            },
            paymentPeriods: [{days: 1, name: 'D1'}, {days: 15, name: 'D15'}, {days: 30, name: 'D30'}],
            paymentMethods: [],            
            selectedCardFees: {
                partnerTax: 0,
                platformFee: 0,
                paymentPeriod: 1,
                fees: []
            },
            canBind: false
        }
    },
    computed: {
        isPartnerTaxDisabled() {
            return !config.partnersConfiguration.contracts.partnerTaxEnabled;
        }
    },
    watch: {
        'value':[
            {
                immediate: true,
                handler: async function() {                                                                            
                    if(this.paymentMethods.length == 0) {
                        await this.bindPaymentMethods();
                    }
                    
                    if(this.value.fees.length == 0) {
                        this.resetCardFees();
                        return;
                    }
                                                            
                    let uniqArray = _.uniqBy(this.value.fees, 'paymentMethodId');

                    for(let i = 0; i <= uniqArray.length - 1; i++) {
                        let selectedPaymentMethod = this.paymentMethods[this.getCurrentPaymentMethodIndex(uniqArray[i].paymentMethodId)];

                        let idx = this.selectedCardFees.fees.findIndex(function(el) { return el.paymentMethod.id == uniqArray[i].paymentMethodId });
                        let cardFee = idx < 0 ? this.createCardFee(selectedPaymentMethod) : this.selectedCardFees.fees[idx];
                        
                        if(this.value.source == 'DEVICE') {
                            let debit = this.value.fees.find(function(el) { return el.paymentMethodId == selectedPaymentMethod.id && el.type == 2 });
                        
                            cardFee.debit.fee.partnerFee = debit.partnerFee;
                            cardFee.debit.fee.salesPersonFee = debit.salesPersonFee;
                        }
                        
                        let creditOnCash = this.value.fees.find(function(el) { return el.paymentMethodId == selectedPaymentMethod.id && el.type == 1 && el.installmentCount == 1 });

                        cardFee.creditOnCash.fee.partnerFee = creditOnCash.partnerFee;
                        cardFee.creditOnCash.fee.salesPersonFee = creditOnCash.salesPersonFee;
                        
                        for(let j = 0; j <= cardFee.creditParcels.length - 1; j++) {
                            let parcel = cardFee.creditParcels[j];
                            let p = this.value.fees.find(function(el) { return el.paymentMethodId == selectedPaymentMethod.id && el.type == 1 && el.installmentCount == parcel.installmentCount });
                            parcel.fee.partnerFee = p.partnerFee;
                            parcel.fee.salesPersonFee = p.salesPersonFee;
                            
                        }

                        if(idx < 0) {
                            this.selectedCardFees.fees.push(cardFee)
                            idx = this.selectedCardFees.fees.length - 1;
                        }
                        this.$set(this.selectedCardFees.fees, idx, cardFee);

                    }

                    this.selectedCardFees.partnerTax = this.value.partnerSettings.partnerTax;// this.value.fees[0].partnerTax;
                    this.selectedCardFees.platformFee = this.value.partnerSettings.platformFee;// this.value.fees[0].platformFee;
                    this.selectedCardFees.paymentPeriod = this.value.fees[0].paymentPeriod;
                }
            },
            {
                immediate: false,
                handler: function() {
                    this.$emit('input', this.value)
                }
            }
        ],
        'selectedCardFees': {
            deep: true,
            handler: function() {
                eventbus.$emit(`card-fees-input:${this.value.source}:refresh`);
            }
        }
    },
    mounted() {
        const self = this;
        eventbus.$on(`card-fees-input:${this.value.source}:refresh`, function() { 
            self.selectedCardFees.platformFee = self.value.partnerSettings.platformFee;
            self.selectedCardFees.partnerTax = self.isPartnerTaxDisabled ? self.value.partnerSettings.partnerTax : self.selectedCardFees.partnerTax;
            self.value.fees = [];
            for(let i = 0; i <= self.selectedCardFees.fees.length - 1; i++) {

                if(self.value.source == 'DEVICE') {
                    self.value.fees.push(self.createSettingsFee(self.selectedCardFees.partnerTax, self.selectedCardFees.platformFee, 
                        self.selectedCardFees.paymentPeriod, self.selectedCardFees.fees[i].paymentMethod.id, self.value.source , 1, self.selectedCardFees.fees[i].debit));
                }

                self.value.fees.push(self.createSettingsFee(self.selectedCardFees.partnerTax, self.selectedCardFees.platformFee, 
                    self.selectedCardFees.paymentPeriod, self.selectedCardFees.fees[i].paymentMethod.id, self.value.source , 1, self.selectedCardFees.fees[i].creditOnCash));

                for(let j = 0; j <= self.selectedCardFees.fees[i].creditParcels.length - 1; j++) {
                    let parcels = self.selectedCardFees.fees[i].creditParcels[j];
                    for(let k = parcels.installmentCount; k <= parcels.maxInstallmentCount; k++) {
                        self.value.fees.push(self.createSettingsFee(self.selectedCardFees.partnerTax, self.selectedCardFees.platformFee, 
                            self.selectedCardFees.paymentPeriod, self.selectedCardFees.fees[i].paymentMethod.id, self.value.source , k, parcels));
                    }

                }
            }
            self.$emit('input', self.value);
        });        
    },
    methods:{
        async bindPaymentMethods() {
            const self = this;
            let result = await paymentMethodService.all(1);
            this.paymentMethods = result.data;
            this.paymentMethods.unshift(this.createDefaultPaymentMethod());
            this.paymentMethods.unshift({
                id: null,
                name: 'Selecione:',
                typeId: 1,
                typeName: 'Crédito',
                disabled: false
            });
        },
        resetCardFees() {
            this.selectedCardFees.partnerTax = this.value.partnerSettings.partnerTax;
            this.selectedCardFees.platformFee = this.value.partnerSettings.platformFee;
            this.selectedCardFees.paymentPeriod = 1;
            this.selectedCardFees.fees = [this.createCardFee(this.createDefaultPaymentMethod())];
        },
        createDefaultPaymentMethod() {
            return {
                id: 0,
                name: 'Padrão',
                typeId: 1,
                typeName: 'Crédito',
                disabled: true
            }
        },
        createCardFee(paymentMethod) {
            let cardFee = {
                paymentMethod: paymentMethod,
                source: this.value.source,
                debit: {
                    paymentMethodTypeId: 2,
                    name: 'Débito',
                    installmentCount: 1,
                    maxInstallmentCount: 1,
                    fee: this.createFee()
                },
                creditOnCash: {
                    paymentMethodTypeId: 1,
                    name: 'Crédito à Vista',
                    installmentCount: 1,
                    maxInstallmentCount: 1,
                    fee: this.createFee()
                },
                creditParcels: [
                    
                ]
            }
            if(config.partnersConfiguration.contracts.installmentsExpanded) {
                for(let i = 2; i <= 18; i++) {
                    cardFee.creditParcels.push({
                        paymentMethodTypeId: 1,
                        name: `Crédito ${i}x`,
                        installmentCount: i,
                        maxInstallmentCount: i,
                        fee: this.createFee()
                    });
                }
            }
            else {
                cardFee.creditParcels = [{
                        paymentMethodTypeId: 1,
                        name: 'Crédito 2/6',
                        installmentCount: 2,
                        maxInstallmentCount: 6,
                        fee: this.createFee()
                    },
                    {
                        paymentMethodTypeId: 1,
                        name: 'Crédito 7/12',
                        installmentCount: 7,
                        maxInstallmentCount: 12,
                        fee: this.createFee()
                    },
                    {
                        paymentMethodTypeId: 1,
                        name: 'Crédito 13/18',
                        installmentCount: 13,
                        maxInstallmentCount: 18,
                        fee: this.createFee()
                    }];
            }
            return cardFee; 
        },
        createFee() {
            return {
                partnerFee: 0,
                salesPersonFee: 0
            }
        },
        createSettingsFee(partnerTax, platformFee, paymentPeriod, paymentMethodId, source, installmentCount, cardFee) {
            return {
                paymentPeriod: paymentPeriod,
                partnerTax: partnerTax,
                platformFee: platformFee,
                salesPersonFee: cardFee.fee.salesPersonFee,
                partnerFee: cardFee.fee.partnerFee,
                
                installmentCount: installmentCount,
                source: source,
                paymentMethodId: paymentMethodId,
                type: cardFee.paymentMethodTypeId
            }
        },
        removePaymentMethod(idx) {
            let s = this.selectedCardFees.fees[idx];
            this.selectedCardFees.fees.splice(idx, 1)
            
            let paymentMethodIdx = this.getCurrentPaymentMethodIndex(s.paymentMethod.id);
            this.changePaymentMethodDisabledState(paymentMethodIdx, false);
        },
        changePaymentMethodDisabledState(idx, disabled) {
            let p = this.paymentMethods[idx];
            p.disabled = disabled;
            this.$set(this.paymentMethods, idx, p);
        },
        getCurrentPaymentMethodIndex(id) {
            return this.paymentMethods.findIndex(function(el) { return el.id == id });
        },
        showPaymentMethodModal() {
            this.paymentMethodModalVisible = true;
        },
        resetModal() {},
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            if(this.paymentMethodModal.id != null) {
                const self = this;
                const paymentMethodIdx = this.getCurrentPaymentMethodIndex(this.paymentMethodModal.id);
                
                this.changePaymentMethodDisabledState(paymentMethodIdx, true);
                let p = this.paymentMethods[paymentMethodIdx];
                let paymentMethod = this.createCardFee(p);
                this.selectedCardFees.fees.push(paymentMethod);
                let idx = this.selectedCardFees.fees.length - 1;
                this.$set(this.selectedCardFees.fees, idx, paymentMethod);
                this.$nextTick(() => {
                    self.paymentMethodModal.id = null;
                    self.$refs.modal.hide()
                })
            }
        },
    }
}
</script>
<style scoped>
.ctn {
    width:100%;
    height: 800px;
    display: flex;
    flex-direction: row;
}
.payment-methods-container {
    width:100%;
    overflow:auto;
    background-color: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: stretch;
    position: relative;    
}

.payment-method {
    flex: 0 0 auto;
    max-width:270px;
    padding:8px;
    margin:6px;
    background-color:#fff;
    border: solid 1px #c8ced3;
    align-self: flex-start;
}

.payment-method-parcel {
    background-color:#fff;
    flex-direction: row;
}
</style>